import { render } from "./InputSimple.vue?vue&type=template&id=0bf071f6&scoped=true"
import script from "./InputSimple.vue?vue&type=script&lang=js"
export * from "./InputSimple.vue?vue&type=script&lang=js"

import "./InputSimple.vue?vue&type=style&index=0&id=0bf071f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf071f6"]])

export default __exports__